(() => {
  if (window.z12CXProductReady) return;
  window.z12CXProductReady = true;
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (_) { return `$${((Number(cents) || 0) / 100).toFixed(2)}`; }
  };

  const init = (root) => {
    if (!root || root.dataset.z12CXReady === 'true') return;
    root.dataset.z12CXReady = 'true';
    const cleanup = [];
    root.z12CXCleanup = () => {
      cleanup.forEach((stop) => stop());
      root.querySelectorAll('video,iframe').forEach(media => media.z12PlaybackCleanup?.());
      root.querySelectorAll('video').forEach((video) => video.pause());
      root.querySelectorAll('iframe').forEach((frame) => frame.removeAttribute('src'));
    };
    let submitting = false;
    const currency = root.dataset.currency || 'USD';
    const addLabel = root.dataset.addLabel || '';
    const soldOutLabel = root.dataset.soldOutLabel || '';
    const tryAgainLabel = root.dataset.tryAgainLabel || '';
    const noRecommendationsLabel = root.dataset.noRecommendationsLabel || '';
    const accessoriesUnavailableLabel = root.dataset.accessoriesUnavailableLabel || '';
    const form = root.querySelector('.cx-product-form');
    const mainVariantInput = root.querySelector('[data-main-variant-input]');
    const price = root.querySelector('[data-current-price]');
    const compare = root.querySelector('[data-compare-price]');
    const compareWrap = root.querySelector('[data-msrp-wrap]');
    const compareLabel = root.querySelector('[data-msrp-label]');
    const savedBadge = root.querySelector('[data-saved-badge]');
    const savedAmount = root.querySelector('[data-saved-amount]');
    const paymentButton = root.querySelector('[data-payment-button]');
    const mobileBuybar = root.querySelector('[data-mobile-buybar]');
    const mobileBuybarPrice = root.querySelector('[data-mobile-buybar-price]');
    const mobileAddButton = root.querySelector('[data-mobile-add-to-cart]');
    const mobileAddLabel = root.querySelector('[data-mobile-add-label]');
    const mainAddButton = root.querySelector('[data-add-to-cart]');
    const packagePreview = root.querySelector('[data-package-gallery-preview]');
    const packagePreviewImage = root.querySelector('[data-package-gallery-image]');

    const hidePackagePreview = () => {
      if (!packagePreview) return;
      packagePreview.hidden = true;
      packagePreview.classList.remove('is-loaded');
      packagePreview.closest('[data-cx-gallery]')?.classList.remove('is-package-preview');
    };

    const showPackagePreview = (card, variant) => {
      if (!packagePreview || !packagePreviewImage || !card || card.dataset.packageStandalone === 'true') {
        hidePackagePreview();
        return;
      }
      const variantImage = variant?.featured_media?.preview_image || variant?.featured_image;
      const imageUrl = variantImage?.src || variantImage?.url || card.dataset.packageImageUrl || '';
      if (!imageUrl) {
        hidePackagePreview();
        return;
      }
      packagePreview.classList.remove('is-loaded');
      packagePreview.hidden = false;
      packagePreview.closest('[data-cx-gallery]')?.classList.add('is-package-preview');
      packagePreviewImage.alt = variantImage?.alt || card.dataset.packageImageAlt || '';
      if (packagePreviewImage.src === imageUrl) {
        packagePreview.classList.add('is-loaded');
        return;
      }
      packagePreviewImage.onload = () => packagePreview.classList.add('is-loaded');
      packagePreviewImage.onerror = hidePackagePreview;
      packagePreviewImage.src = imageUrl;
    };

    const stopGalleryMedia = () => {
      root.querySelectorAll('.cx-gallery__slide video').forEach(video => {
        video.z12PlaybackCleanup?.(); video.pause(); video.preload = 'none';
        const source = video.getAttribute('src');
        const sources = [...video.querySelectorAll('source')].map(node => [node, node.getAttribute('src')]);
        video.removeAttribute('src'); sources.forEach(([node]) => node.removeAttribute('src')); video.load();
        if (source) video.setAttribute('src', source);
        sources.forEach(([node, url]) => { if (url) node.setAttribute('src', url); });
        video.load();
      });
      root.querySelectorAll('[data-external-video-frame]').forEach(frame => {
        frame.z12PlaybackCleanup?.(); frame.removeAttribute('src');
        frame.closest('[data-external-video-shell]')?.classList.remove('is-loaded');
      });
    };
    cleanup.push(stopGalleryMedia);
    const setGallery = (id, requestPlay = false) => {
      hidePackagePreview();
      root.querySelectorAll('[data-media-id]').forEach((el) => {
        if (el.matches('.cx-gallery__slide,.cx-gallery__thumb,.cx-gallery__video-dock')) el.classList.toggle('is-active', el.dataset.mediaId === id);
      });
      const activeSlide = root.querySelector(`.cx-gallery__slide[data-media-id="${id}"]`);
      const activeType = activeSlide?.dataset.mediaType;
      const wantsPlayback = requestPlay && (activeType === 'video' || activeType === 'external_video');
      root.querySelectorAll('[data-external-video-frame]').forEach((frame) => {
        const shell = frame.closest('[data-external-video-shell]');
        if (frame.closest('.cx-gallery__slide') === activeSlide) {
          if (wantsPlayback && window.z12PlayRequestedMedia) {
            window.z12PlayRequestedMedia(frame, () => frame.isConnected && frame.closest('.cx-gallery__slide')?.classList.contains('is-active') && !document.hidden, stopGalleryMedia);
            shell?.classList.add('is-loaded');
          } else if (!frame.hasAttribute('src') && frame.dataset.videoSrc) {
            frame.src = frame.dataset.videoSrc;
            frame.addEventListener('load', () => shell?.classList.add('is-loaded'), { once: true });
          }
        } else {
          frame.z12PlaybackCleanup?.();
          frame.removeAttribute('src');
          shell?.classList.remove('is-loaded');
        }
      });
      const currentIndex = [...root.querySelectorAll('.cx-gallery__slide[data-media-id]')].findIndex((slide) => slide.dataset.mediaId === id);
      const counter = root.querySelector('[data-gallery-current]');
      if (counter && currentIndex >= 0) counter.textContent = String(currentIndex + 1);
      root.querySelectorAll('[data-gallery-mode]').forEach((button) => {
        const shouldActivate = button.dataset.galleryMode === 'video'
          ? activeType === 'video' || activeType === 'external_video'
          : activeType !== 'video' && activeType !== 'external_video';
        button.classList.toggle('is-active', shouldActivate);
      });
      root.querySelectorAll('.cx-gallery__slide video').forEach((video) => {
        if (video.closest('.cx-gallery__slide')?.classList.contains('is-active')) {
          if (wantsPlayback) {
            if (window.z12PlayRequestedMedia) window.z12PlayRequestedMedia(video, () => video.isConnected && video.closest('.cx-gallery__slide')?.classList.contains('is-active') && !document.hidden, stopGalleryMedia);
            else video.play().catch(() => { video.controls = true; });
          }
          return;
        }
        video.z12PlaybackCleanup?.();
        video.pause();
      });
    };
    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => setGallery(thumb.dataset.mediaId, true)));
    const mediaIds = [...root.querySelectorAll('.cx-gallery__slide[data-media-id]')].map((slide) => slide.dataset.mediaId);
    const moveMainGallery = (direction) => {
      if (!mediaIds.length) return;
      const activeId = root.querySelector('.cx-gallery__slide.is-active')?.dataset.mediaId;
      const currentIndex = Math.max(0, mediaIds.indexOf(activeId));
      const nextIndex = (currentIndex + direction + mediaIds.length) % mediaIds.length;
      setGallery(mediaIds[nextIndex], true);
      root.querySelector(`[data-gallery-thumb][data-media-id="${mediaIds[nextIndex]}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    root.querySelector('[data-gallery-main-prev]')?.addEventListener('click', () => moveMainGallery(-1));
    root.querySelector('[data-gallery-main-next]')?.addEventListener('click', () => moveMainGallery(1));

    const galleryStage = root.querySelector('.cx-gallery__stage');
    const onGalleryVisibility = () => { if (document.hidden) stopGalleryMedia(); };
    document.addEventListener('visibilitychange', onGalleryVisibility);
    cleanup.push(() => document.removeEventListener('visibilitychange', onGalleryVisibility));
    if (galleryStage && 'IntersectionObserver' in window) {
      const galleryObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => !entry.isIntersecting || entry.intersectionRatio <= .03)) stopGalleryMedia();
      }, { threshold: [0, .03] });
      galleryObserver.observe(galleryStage); cleanup.push(() => galleryObserver.disconnect());
    }
    let gallerySwipe = null;
    const resetGallerySwipe = () => {
      if (gallerySwipe && galleryStage?.hasPointerCapture?.(gallerySwipe.pointerId)) {
        galleryStage.releasePointerCapture(gallerySwipe.pointerId);
      }
      gallerySwipe = null;
      galleryStage?.classList.remove('is-swiping');
    };
    galleryStage?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || !window.matchMedia('(max-width: 749px)').matches) return;
      if (event.target.closest('button,video,iframe,model-viewer,[data-external-video-shell]')) return;
      gallerySwipe = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false
      };
      galleryStage.setPointerCapture?.(event.pointerId);
    });
    galleryStage?.addEventListener('pointermove', (event) => {
      if (!gallerySwipe || gallerySwipe.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - gallerySwipe.startX;
      const deltaY = event.clientY - gallerySwipe.startY;
      if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
        gallerySwipe.moved = true;
        galleryStage.classList.add('is-swiping');
      }
    });
    galleryStage?.addEventListener('pointerup', (event) => {
      if (!gallerySwipe || gallerySwipe.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - gallerySwipe.startX;
      const deltaY = event.clientY - gallerySwipe.startY;
      const threshold = Math.max(44, galleryStage.clientWidth * 0.1);
      const shouldMove = gallerySwipe.moved
        && Math.abs(deltaX) >= threshold
        && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
      resetGallerySwipe();
      if (shouldMove) moveMainGallery(deltaX < 0 ? 1 : -1);
    });
    galleryStage?.addEventListener('pointercancel', resetGallerySwipe);
    root.querySelectorAll('[data-gallery-mode]').forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.galleryMode === 'video') {
        const videoId = button.dataset.videoMediaId;
        if (videoId) setGallery(videoId, true);
        return;
      }
      const firstFeature = root.querySelector('.cx-gallery__slide[data-media-type="image"],.cx-gallery__slide[data-media-type="model"]');
      if (firstFeature?.dataset.mediaId) setGallery(firstFeature.dataset.mediaId);
    }));
    const initialMedia = root.querySelector('.cx-gallery__slide.is-active[data-media-id]');
    if (initialMedia?.dataset.mediaId) setGallery(initialMedia.dataset.mediaId);
    const rail = root.querySelector('[data-gallery-rail]');
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => rail?.scrollBy({ left: -220, behavior: 'smooth' }));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => rail?.scrollBy({ left: 220, behavior: 'smooth' }));

    const videoPreviewOnIntent = root.dataset.videoPreviewOnIntent === 'true';
    const canStartVideoPreview = (dock) => !videoPreviewOnIntent || (!document.hidden && !dock.classList.contains('is-active') && dock.matches(':hover, :focus-visible'));
    const startVideoThumbnail = (dock) => {
      if (!dock || dock.dataset.videoStarted === 'true') return;
      if (!canStartVideoPreview(dock)) return;
      dock.dataset.videoStarted = 'true';
      const nativeVideo = dock.querySelector('[data-video-thumb-native]');
      if (nativeVideo) {
        nativeVideo.play().then(() => dock.classList.add('is-playing')).catch(() => {});
        return;
      }
      const frame = dock.querySelector('[data-video-thumb-frame]');
      if (!frame || !frame.dataset.videoSrc) return;
      const loadFrame = () => {
        if (!canStartVideoPreview(dock)) {
          dock.dataset.videoStarted = 'false';
          return;
        }
        frame.src = frame.dataset.videoSrc;
        frame.addEventListener('load', () => dock.classList.add('is-playing'), { once: true });
      };
      if (videoPreviewOnIntent) loadFrame();
      else if ('requestIdleCallback' in window) window.requestIdleCallback(loadFrame, { timeout: 1200 });
      else window.setTimeout(loadFrame, 350);
    };
    const videoThumbs = root.querySelectorAll('[data-video-thumb]');
    if (videoPreviewOnIntent) {
      videoThumbs.forEach((dock) => {
        let intentTimer = null;
        const cancelPreview = () => { window.clearTimeout(intentTimer); intentTimer = null; };
        cleanup.push(cancelPreview);
        const queuePreview = () => {
          cancelPreview();
          intentTimer = window.setTimeout(() => startVideoThumbnail(dock), 300);
        };
        dock.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') queuePreview();
        });
        dock.addEventListener('pointerleave', cancelPreview);
        dock.addEventListener('focusin', () => {
          if (dock.matches(':focus-visible')) queuePreview();
        });
        dock.addEventListener('focusout', cancelPreview);
        dock.addEventListener('click', cancelPreview);
      });
    } else if ('IntersectionObserver' in window) {
      const videoThumbObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          startVideoThumbnail(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '120px 0px', threshold: 0.15 });
      videoThumbs.forEach((dock) => videoThumbObserver.observe(dock));
      cleanup.push(() => videoThumbObserver.disconnect());
    } else {
      videoThumbs.forEach(startVideoThumbnail);
    }

    const updatePrice = (variant) => {
      if (!variant) return;
      if (price) price.textContent = money(variant.price, currency);
      if (mobileBuybarPrice) mobileBuybarPrice.textContent = money(variant.price, currency);
      const compareValue = Number(variant.compare_at_price || 0);
      const currentValue = Number(variant.price || 0);
      const onSale = root.dataset.hideCompare !== 'true' && compareValue > currentValue;
      if (compare) compare.textContent = money(compareValue, currency);
      if (compareWrap) compareWrap.hidden = !onSale;
      if (compareLabel) compareLabel.hidden = !onSale;
      if (savedBadge) savedBadge.hidden = !onSale;
      if (savedAmount) savedAmount.textContent = onSale ? money(compareValue - currentValue, currency) : '';
      const button = root.querySelector('[data-add-to-cart]');
      if (button) button.disabled = submitting || variant.available === false;
      const label = root.querySelector('[data-add-label]');
      if (label) label.textContent = variant.available === false ? soldOutLabel : addLabel;
      if (mobileAddButton) mobileAddButton.disabled = variant.available === false;
      if (mobileAddLabel) mobileAddLabel.textContent = variant.available === false ? soldOutLabel : addLabel;
    };

    const packageVariants = (card) => {
      try { return JSON.parse(card.querySelector('[data-package-variants]')?.textContent || '[]'); }
      catch (_) { return []; }
    };

    const cards = [...root.querySelectorAll('[data-package]')];
    const mainCard = cards.find((card) => card.dataset.packageStandalone === 'true');
    const resolveVariant = (card) => {
      const chosen = [...card.querySelectorAll('[data-package-option]')].map((input) => input.value);
      return packageVariants(card).find((item) => item.options.every((value, index) => value === chosen[index]));
    };
    const applyQuantity = (variant) => {
      const input = root.querySelector('[data-qty-input]');
      if (!input) return;
      const rule = variant?.quantity_rule || {};
      const min = Number(rule.min || 1), step = Number(rule.increment || 1);
      input.min = String(min);
      input.step = String(step);
      if (rule.max) input.max = String(rule.max); else input.removeAttribute('max');
      const value = Math.max(min, Number(input.value || min));
      input.value = String(min + Math.ceil((value - min) / step) * step);
      if (rule.max && Number(input.value) > rule.max) input.value = String(rule.max);
    };
    const syncURL = (card, variant) => {
      const url = new URL(location.href);
      if (!variant) {
        url.searchParams.delete('variant');
        url.searchParams.delete('z12_package');
        url.searchParams.delete('z12_variant');
      } else if (card === mainCard) {
        url.searchParams.set('variant', String(variant.id));
        url.searchParams.delete('z12_package');
        url.searchParams.delete('z12_variant');
      } else {
        const baseVariant = packageVariants(mainCard).find((item) => item.options.every((value, index) => value === variant.options[index]));
        if (baseVariant) url.searchParams.set('variant', String(baseVariant.id)); else url.searchParams.delete('variant');
        url.searchParams.set('z12_package', card.dataset.productId);
        url.searchParams.set('z12_variant', String(variant.id));
      }
      history.replaceState(null, '', url.toString());
    };
    const selectPackage = (card, selectedVariant, updateURL = true) => {
      if (!card) return;
      const variant = selectedVariant || resolveVariant(card);
      cards.forEach((item) => {
        const active = item === card;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-checked', String(active));
      });
      const error = root.querySelector('[data-z12cx-error]');
      if (error) error.hidden = true;
      card.dataset.variantId = variant ? String(variant.id) : '';
      card.dataset.price = variant ? String(variant.price) : '';
      card.dataset.comparePrice = variant ? String(variant.compare_at_price || 0) : '';
      card.dataset.available = String(!!variant?.available);
      if (mainVariantInput) mainVariantInput.value = variant ? String(variant.id) : '';
      if (variant) {
        updatePrice(variant);
        applyQuantity(variant);
        const cardPrice = card.querySelector('[data-package-price]');
        if (cardPrice) cardPrice.textContent = money(variant.price, currency);
        const cardCompare = card.querySelector('[data-package-compare]');
        const onSale = root.dataset.hideCompare !== 'true' && variant.compare_at_price > variant.price;
        if (cardCompare) { cardCompare.textContent = money(variant.compare_at_price || 0, currency); cardCompare.hidden = !onSale; }
        const saving = card.querySelector('[data-package-saving]');
        if (saving) { saving.hidden = !onSale; const amount = saving.querySelector('span'); if (amount) amount.textContent = money(variant.compare_at_price - variant.price, currency); }
        if (card === mainCard) {
          hidePackagePreview();
          const mediaId = variant.featured_media?.id;
          if (mediaId && mediaIds.includes(String(mediaId))) setGallery(String(mediaId));
        } else {
          showPackagePreview(card, variant);
          root.querySelectorAll('.cx-gallery__slide video').forEach((video) => video.pause());
          root.querySelectorAll('[data-external-video-frame]').forEach((frame) => { frame.z12PlaybackCleanup?.(); frame.removeAttribute('src'); });
        }
      } else {
        if (price) price.textContent = root.dataset.unavailableLabel || soldOutLabel;
        [compareWrap, compareLabel, savedBadge].forEach((node) => { if (node) node.hidden = true; });
        if (mainAddButton) mainAddButton.disabled = true;
        const label = root.querySelector('[data-add-label]');
        if (label) label.textContent = root.dataset.unavailableLabel || soldOutLabel;
        hidePackagePreview();
      }
      if (updateURL) syncURL(card, variant);
      mainVariantInput?.dispatchEvent(new Event('change', { bubbles: true }));
      syncPayment();
    };
    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('select,[data-package-includes]')) return;
        selectPackage(card);
      });
      card.addEventListener('keydown', (event) => {
        if (event.target.closest('select,[data-package-includes]')) return;
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); selectPackage(card); }
        else if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) {
          event.preventDefault();
          const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
          const next = cards[(cards.indexOf(card) + direction + cards.length) % cards.length];
          next.focus();
          selectPackage(next);
        }
      });
      card.querySelectorAll('[data-package-option]').forEach((select) => select.addEventListener('change', () => selectPackage(card)));
    });

    const qty = root.querySelector('[data-qty-input]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qty.stepDown(); qty.dispatchEvent(new Event('change', { bubbles: true })); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qty.stepUp(); qty.dispatchEvent(new Event('change', { bubbles: true })); });

    const addonHost = root.querySelector('[data-cx-addons]');
    const loadAddons = () => {
      if (!addonHost || addonHost.dataset.loaded === 'true') return;
      addonHost.dataset.loaded = 'true';
      const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?section_id=${encodeURIComponent(root.dataset.sectionId)}&product_id=${encodeURIComponent(root.dataset.productId)}&limit=4&intent=complementary`;
      fetch(url).then((response) => response.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const response = doc.querySelector('.cx-recommendation-response');
        addonHost.querySelector('.cx-addons__loading')?.replaceWith(response || document.createTextNode(noRecommendationsLabel));
        addonHost.querySelectorAll('[data-addon-select]').forEach((select) => select.addEventListener('change', () => {
          const card = select.closest('[data-addon-card]');
          const option = select.selectedOptions[0];
          const check = card?.querySelector('[data-addon-id]');
          if (check) { check.dataset.addonId = option.value; check.dataset.addonPrice = option.dataset.price || '0'; }
        }));
      }).catch(() => {
        const loading = addonHost.querySelector('.cx-addons__loading');
        if (loading) loading.textContent = accessoriesUnavailableLabel;
      });
    };
    if (addonHost && 'IntersectionObserver' in window) {
      const addonObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadAddons();
      }, { rootMargin: '600px 0px' });
      addonObserver.observe(addonHost);
      cleanup.push(() => addonObserver.disconnect());
    } else if (addonHost) {
      window.setTimeout(loadAddons, 1200);
    }

    function syncPayment() {
      const hasExtra = !!root.querySelector('[data-addon-id]:checked,[data-warranty-id]:checked');
      const packageCard = root.querySelector('[data-package].is-selected');
      const hasBundle = packageCard && packageCard.dataset.packageStandalone !== 'true';
      if (paymentButton) paymentButton.hidden = hasExtra || hasBundle || !mainVariantInput?.value || mainAddButton?.disabled || !qty?.checkValidity();
      const paymentNote = root.querySelector('[data-z12cx-payment-note]');
      if (paymentNote) paymentNote.hidden = !paymentButton || paymentButton.hidden;
    }
    root.addEventListener('change', syncPayment);
    root.addEventListener('input', syncPayment);
    const params = new URL(location.href).searchParams;
    let initialCard = cards.find((card) => card.dataset.productId === params.get('z12_package')) || mainCard;
    let initialVariant = packageVariants(initialCard).find((variant) => String(variant.id) === params.get('z12_variant'));
    if (initialVariant && initialCard !== mainCard) {
      initialCard.querySelectorAll('[data-package-option]').forEach((select, index) => { select.value = initialVariant.options[index]; });
    } else initialVariant = resolveVariant(initialCard);
    selectPackage(initialCard, initialVariant, false);
    syncPayment();

    mobileAddButton?.addEventListener('click', () => {
      if (!form || !mainAddButton || mainAddButton.disabled) return;
      form.requestSubmit(mainAddButton);
    });
    if (mainAddButton && mobileAddButton) {
      const syncMobileButton = () => {
        mobileAddButton.disabled = mainAddButton.disabled;
        mobileAddButton.setAttribute('aria-busy', mainAddButton.getAttribute('aria-busy') || 'false');
      };
      new MutationObserver(syncMobileButton).observe(mainAddButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
      syncMobileButton();
    }
    const purchaseArea = root.querySelector('.cx-purchase');
    if (mobileBuybar && purchaseArea && 'IntersectionObserver' in window) {
      const purchaseObserver = new IntersectionObserver((entries) => {
        mobileBuybar.classList.toggle('is-hidden', entries.some((entry) => entry.isIntersecting));
      }, { threshold: 0.15 });
      purchaseObserver.observe(purchaseArea);
      cleanup.push(() => purchaseObserver.disconnect());
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = root.querySelector('[data-add-to-cart]');
      const activeCard = root.querySelector('[data-package].is-selected');
      const activeVariant = activeCard && resolveVariant(activeCard);
      if (submitting || !activeVariant?.available || String(activeVariant.id) !== mainVariantInput?.value || button?.disabled) return;
      if (qty && !qty.checkValidity()) { qty.reportValidity(); return; }
      const items = [{ id: Number(mainVariantInput.value), quantity: Math.max(1, Number(qty?.value || 1)) }];
      root.querySelectorAll('[data-addon-id]:checked').forEach((input) => items.push({ id: Number(input.dataset.addonId), quantity: 1 }));
      const warranty = root.querySelector('[data-warranty-id]:checked');
      if (warranty) items.push({ id: Number(warranty.dataset.warrantyId), quantity: 1 });
      submitting = true;
      button?.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(root.dataset.cartUrl || '/cart');
      } catch (_) {
        const error = root.querySelector('[data-z12cx-error]');
        if (error) { error.textContent = tryAgainLabel; error.hidden = false; }
        const label = root.querySelector('[data-add-label]');
        if (label) label.textContent = tryAgainLabel;
        if (button) button.disabled = false;
      } finally {
        submitting = false;
        const currentCard = root.querySelector('[data-package].is-selected');
        if (button) button.disabled = !currentCard || !resolveVariant(currentCard)?.available;
        syncPayment();
        button?.removeAttribute('aria-busy');
      }
    });


    if (root.hasAttribute('data-cv-package-tools')) {
      root.cvPackageSelect = (card, variant) => {
        card.dataset.variantId = variant ? String(variant.id) : '';
        card.dataset.price = variant ? String(variant.price) : '';
        card.dataset.comparePrice = variant ? String(variant.compare_at_price || 0) : '';
        selectPackage(card, variant, false);
        if (variant) {
          const cardPrice = card.querySelector('[data-package-price]');
          if (cardPrice) cardPrice.textContent = money(variant.price, currency);
          const cardCompare = card.querySelector('[data-package-compare]');
          if (cardCompare) {
            cardCompare.textContent = money(variant.compare_at_price || 0, currency);
            cardCompare.hidden = !(variant.compare_at_price > variant.price);
          }
          if (card.dataset.packageStandalone === 'true') {
            const id = variant.featured_media?.id || card.dataset.packageMediaId;
            if (id) setGallery(String(id));
          }
        } else {
          if (price) price.textContent = root.dataset.unavailableLabel || soldOutLabel;
          [compareWrap, compareLabel, savedBadge].forEach((node) => { if (node) node.hidden = true; });
        }
        if (mainAddButton?.getAttribute('aria-busy') === 'true') mainAddButton.disabled = true;
        if (paymentButton && !variant?.available) paymentButton.hidden = true;
      };
    }

    root.querySelectorAll('[data-campaign-end]').forEach((campaign) => {
      const end = new Date(campaign.dataset.campaignEnd).getTime();
      const boxes = campaign.querySelectorAll('[data-countdown] span');
      if (!Number.isFinite(end) || boxes.length < 4) return;
      const tick = () => {
        const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        boxes.forEach((box, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (box.textContent !== value) box.textContent = value;
        });
      };
      tick(); const timer = window.setInterval(tick, 1000); cleanup.push(() => window.clearInterval(timer));
    });
  };

  const boot = () => document.querySelectorAll('[data-z12cx-product]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-z12cx-product]').forEach((root) => root.z12CXCleanup?.()));
})();

